import styled from 'styled-components';
import { gridConfig as breakpoints } from '../../fuse-responsive-grid/src/grid';
import { StickyDrawer } from '../../fuse-sticky-drawer/src/sticky-drawer';

const sidesEnum = Object.freeze({
	left: 'left',
	right: 'right',
	top: 'top',
	bottom: 'bottom',
});

const getCssTranslate = () => ({
	[sidesEnum.left]: { opened: 'translateX(100%)' },
	[sidesEnum.right]: { opened: 'translateX(-100%)' },
	[sidesEnum.top]: { opened: 'translateY(100%)' },
	[sidesEnum.bottom]: { opened: 'translateY(-100%)' },
});

const animationDelay = '200ms';

const Dialog = styled.div.attrs({
	className: 'fuse-drawer',
})`
	${(props) => {
		const cssTranslate = getCssTranslate()[props.slidePosition];
		const translate = props.open ? 'translateX(0%)' : cssTranslate.opened;

		return `
			background-color: var(--color-functional-panelLight);
			display: block;
			position: fixed;
			top: 0;
			left: 0;
			bottom: 0;
			transition: ${animationDelay};
			transform: ${translate};
			will-change: transform, visibility, height;
			visibility: ${props.open ? 'visible' : 'hidden'};
			width: 100%;
			z-index: ${props.zIndex};
			`;
	}}
`;

const Content = styled.div.attrs({
	className: 'fuse-drawer__content',
})`
	display: flex;
	flex-flow: column nowrap;
	height: 100%;
	position: relative;
	width: 100%;
	transition: ${animationDelay};
	will-change: transform, visibility, height;
	visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
`;

const DrawerBody = styled.div.attrs({
	className: 'fuse-drawer__body',
})`
	${({ hasPromotionalArea, stickyDrawerHeight }) => `
			flex: 1 1 100%;
			padding-top: ${hasPromotionalArea ? `0px` : `var(--spacing-global-space7)`};
			margin: 0 0 ${stickyDrawerHeight}px 0;
			overflow: auto;
			width: 100%
		`};
`;

const StyledStickyDrawer = styled(StickyDrawer).attrs({
	className: 'fuse-drawer__sticky-drawer',
	'data-testid': 'fuse-drawer__sticky-drawer',
})`
	position: absolute;
`;

const DrawerPromotionalArea = styled.div.attrs({
	className: 'fuse-drawer__body-promotional-area',
})`
	width: 100%;
`;

const DrawerBodyContent = styled.div.attrs({
	className: 'fuse-drawer__body-content',
})`
	${({ hasPromotionalArea }) => `
			padding: var(--spacing-global-space7) ${breakpoints.xxs.margin} ${breakpoints.xxs.margin} ${
	breakpoints.xxs.margin
};
			${hasPromotionalArea ? `` : `padding-top: 0px;`}
		
			@media only screen and (min-width: ${breakpoints.m.minWidth}) {
				padding: var(--spacing-global-space7) ${breakpoints.m.margin} ${breakpoints.m.margin} ${
	breakpoints.m.margin
};
				${hasPromotionalArea ? `` : `padding-top: 0px;`}

			}
		`};
`;

export {
	Content,
	Dialog,
	DrawerBody,
	DrawerBodyContent,
	DrawerPromotionalArea,
	StyledStickyDrawer,
};
